(() => {
  'use strict';

  const retargetRemovedAssessmentLinks = (root = document) => {
    root.querySelectorAll('a[href*="#fitobotanic-index"]').forEach((link) => {
      link.setAttribute('href', '/#objetivos-fitobotanic');
    });
  };

  const openCookiePreferences = async (trigger) => {
    const previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : trigger;
    const restoreFocus = () => window.setTimeout(() => previousFocus?.focus?.({ preventScroll: true }), 250);
    const privacyBanner = window.privacyBanner;
    const customerPrivacy = window.Shopify?.customerPrivacy;

    if (privacyBanner && typeof privacyBanner.showPreferences === 'function') {
      await privacyBanner.showPreferences();
      restoreFocus();
      return;
    }

    if (customerPrivacy && typeof customerPrivacy.showPreferences === 'function') {
      customerPrivacy.showPreferences();
      restoreFocus();
      return;
    }

    const injectedTrigger = document.querySelector(
      '[data-shopify-privacy-preferences], #shopify-pc__prefs__button, button[name="customer_privacy_preferences"]'
    );
    if (injectedTrigger instanceof HTMLElement && injectedTrigger !== trigger) {
      injectedTrigger.click();
      restoreFocus();
    }
  };

  const bindCookiePreferences = (root = document) => {
    root.querySelectorAll('[data-fb-cookie-preferences]').forEach((button) => {
      if (button.dataset.fbCookiePreferencesBound === 'true') return;
      button.dataset.fbCookiePreferencesBound = 'true';
      button.addEventListener('click', () => {
        openCookiePreferences(button).catch(() => {});
      });
    });
  };

  const boot = () => {
    retargetRemovedAssessmentLinks(document);
    bindCookiePreferences(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    retargetRemovedAssessmentLinks(event.target);
    bindCookiePreferences(event.target);
  });
})();
